exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarTime .h2_title[data-v-bf51d824] {\n  font-weight: normal;\n}\n#cardDivTV[data-v-bf51d824] {\n  width: 100%;\n}\n.h2_title[data-v-bf51d824] {\n  text-align: left;\n  color: grey;\n}\n", ""]);

// exports
